<template>
  <el-form ref="form" :model="loginForm" :rules="rules" label-width="0" @keyup.enter.native="handleLogin">
    <h3 class="login-title">手机验证码登录</h3>
    <el-form-item prop="phone">
      <el-input
        v-model.number.trim="loginForm.phone"
        placeholder="请输入您的手机号，如果没有账号，将为您创建账号"
      >
      </el-input>
    </el-form-item>
    <el-form-item prop="code">
      <el-row :gutter="20">
        <el-col :span="14">
          <el-input v-model="loginForm.code" placeholder="请输入验证码">
          </el-input>
        </el-col>
        <el-col :span="10">
          <el-button
            type="primary"
            plain
            @click="sendMessage"
            :disabled="isSend"
          >
            <template v-if="!isSend"> 获取短信验证码 </template>
            <template v-else> {{ count }} 秒后重试 </template>
          </el-button>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item style="margin-top: -10px">
      <el-checkbox v-model="checkLoginStatus">7天内自动登录</el-checkbox>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" style="width: 100%" @click="handleLogin"
        >登录</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import { sendCode } from '@/api/user'
import { isPhone } from '@/util/validate'
export default {
  data() {
    const validatorPhone = (rule, value, callback) => {
      if (value && !isPhone(value)) {
        callback(new Error('请输入正确的手机号'))
      }
      callback()
    }
    return {
      loginForm: {
        phone: '',
        code: '',
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatorPhone, trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
        ],
      },
      checkLoginStatus: false,
      isSend: false,
      timer: null,
      count: 60,
    }
  },
  methods: {
    sendMessage() {
      this.$refs.form.validateField('phone', (valid) => {
        if (!valid) {
          const data = {
            mobile: this.loginForm.phone,
          }
          sendCode(data).then(() => {
            this.validateBtn()
          })
        }
      })
    },
    validateBtn() {
      if (!this.timer) {
        this.count = 60
        this.isSend = true
        this.timer = setInterval(() => {
          if (this.count > 1 && this.count <= 60) {
            this.count--
          } else {
            this.isSend = false
            clearInterval(this.timer) // 清除定时器
            this.timer = null
          }
        }, 1000)
      }
    },
    handleLogin() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在登录中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })
          this.$store
            .dispatch('user/phoneLogin', {
              ...this.loginForm,
              checkLoginStatus: this.checkLoginStatus,
            })
            .then(() => {
              loading.close()
              this.loginForm = {}
            })
            .catch(() => {
              loading.close()
            })
        }
      })
    },
  },
}
</script>

<style scoped>
.login-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
}
</style>
